<template>
  <div class="is-flex is-justify-content-space-between is-align-items-center">
    <label class="label">Status</label>
    <BaseDropdown
      :leftOffset="-10"
      wrapperClasses="column is-8 pr-0 pt-0"
      dialogClass="p-0"
      :onDialogChange="handleChange"
    >
      <template v-slot:toggle-button="{ handleToggle }">
        <div @click="handleToggle" class="pick-container">{{ value || 'Choose...' }}</div>
      </template>
      <div class="container py-3 px-2 max-width-dropdown">
        <label v-for="option in options" :key="option.id">
          <input type="radio" name="status" :value="option.text" hidden />
          <p class="search_result has-text-right" :disabled="option.disabled">{{ option.text }}</p>
        </label>
      </div>
    </BaseDropdown>
  </div>
</template>

<script>
import BaseDropdown from '@/components/BaseDropdown'

export default {
  name: 'Status',
  components: {
    BaseDropdown
  },
  data () {
    return {
      options: [
        { id: 'completed', text: 'completed' },
        { id: 'vetted', text: 'vetted' },
        { id: 'unvetted', text: 'unvetted' },
        { id: 'irrelevant', text: 'irrelevant' }
      ]
    }
  },
  props: {
    value: {
      type: String
    },
    applicantId: {
      type: Number
    },
    owner: {
      type: String,
      default: null
    }
  },
  methods: {
    async handleChange ({ target: { value: status } }, closeModal) {
      try {
        await this.$network_utils.updateApplicant({ applicant_id: this.applicantId, status: status, ...(!this.owner && { owner: this.$utils.getOwner().name }) })
        if (['vetted', 'completed'].includes(status)) {
          await this.$network_utils.postStat({
            title: 'Applicant Vetted',
            designator: 'applicant_vetted',
            status: 'active',
            owner: this.$utils.getOwner().name,
            priority: 5,
            resource_type: 'Applicant',
            resource_id: this.applicantId
          })
        }
        this.$emit('input', status)
        closeModal()
        this.$utils.emit('show_toast', { text: 'הצלחה' })
      } catch (e) {
        console.log(e)
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>

<style scoped>
  .max-width-dropdown {
    max-width: 250px;
    min-width: 250px;
    border: 2px solid rgba(0, 0, 0, 0.3);
    max-height: 400px;
    overflow-y: scroll;
  }
  .pick-container {
    cursor: pointer;
    background: url('/black_down_arrow.svg') no-repeat;
    background-position-y: center;
    background-position-x: 10px;
    background-size: 15px;
    width: 100%;
    display: inline-block;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    text-align: right;
  }
</style>
